// extracted by mini-css-extract-plugin
export default {"loading":"loading-dots_loading__Ubkj+","spacer":"loading-dots_spacer__fygxf","blink":"loading-dots_blink__Lfzfd","loading2":"loading-dots_loading2__QekeV"};